import type { CheckboxCustomEvent } from '@ionic/react'
import { ComponentProps } from 'react'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { IonCheckbox } from './styled'

type CheckboxProps = {
  label: string
  onChange: (value: boolean) => void
  checked: boolean
} & Omit<ComponentProps<typeof IonCheckbox>, 'onChange'>

export function Checkbox({
  label,
  onChange,
  checked,
  ...checkboxProps
}: CheckboxProps) {
  const { parserI18nMessage } = useParserI18nMessage()
  return (
    <IonCheckbox
      checked={checked}
      onIonChange={(e: CheckboxCustomEvent) => {
        onChange(e.detail.checked)
      }}
      {...checkboxProps}
      labelPlacement='start'
      justify='space-between'
      mode='md'
    >
      {parserI18nMessage(label)}
    </IonCheckbox>
  )
}
